var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"Radio"},[_c('input',{ref:"radio",attrs:{"name":_vm.radioName,"type":"radio"},domProps:{"value":_vm.radioVal},on:{"change":function($event){return _vm.changeRadio(_vm.radioVal)}}}),_vm._v(" "),_c('span',{staticClass:"tipsBox"},[_vm._t("tips")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596b2cae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio.vue
// module id = null
// module chunks = 